<template>
  <div>
    <navbar/>
    <container/>
  </div>
</template>

<script>
import Nav from "../../../Nav"
import Container from "./DemonstrativoRepasseContainerGrafico"
export default {
  name: "DemonstrativoRepasseGrafico",
  components: {
    "navbar": Nav,
    "container": Container
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/demonstrativo/repasse/DemonstrativoRepasseGrafico.vue